import { render } from "./BlockProgress.vue?vue&type=template&id=bb1caa84"
import script from "./BlockProgress.vue?vue&type=script&lang=js"
export * from "./BlockProgress.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__